const backendEmailUserRegex = /^[-!#$%&'*+/=?^_`{}|~0-9A-Z]+(\.[-!#$%&'*+/=?^_`{}|~0-9A-Z]+)*$|^"([\x01-\x08\x0b\x0c\x0e-\x1f!#-[\]-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*"$/i;

const backendEmailDomainRegex = /^(?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\.)+(?:[A-Z0-9-]{2,63})$/i;

export const isBackendValidEmail = (value?: string | null): boolean => {
    if (!value) {
        return false;
    }

    const atIndex = value.lastIndexOf('@');
    if (atIndex === -1) {
        return false;
    }

    const userPart = value.slice(0, atIndex);
    const domainPart = value.slice(atIndex + 1);

    if (!userPart || !domainPart) {
        return false;
    }

    if (!backendEmailUserRegex.test(userPart)) {
        return false;
    }

    if (domainPart === 'localhost') {
        return true;
    }

    return backendEmailDomainRegex.test(domainPart);
};


